<script>
import { BModal, VBTooltip } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  data () {
    return {
      link: {
        title: '',
        url: '',
      },
    };
  },

  methods: {
    showNewLinkModal () {
      this.$refs['link-modal'].show();
    },

    showLink (link) {
      if (! link) return;

      this.link = link;

      this.$refs['link-show-modal'].show();
    },
  },
};
</script>
